const progressPage = {
  "progress.title": "Progress Overview",
  "your.progress": "Your Progress",
  "progress.description": "Every session builds your story. Discover your strengths, weaknesses and where to push next.",
  "progress.byb_iq.explanation":
    "BYB IQ is your overall performance rating based on all sessions in the selected time period. It's calculated from the average of your five metrics and adjusted for game speed, mode, and complexity.",

  "progress.section.byb_iq": "BYB IQ Progress",
  "progress.section.progress-timeline": "Progress Timeline",
  "progress.section.skill-radar": "Skill Radar",
  "progress.section.training-streak": "Training Streak",
  "progress.section.progress.all_time": "All Time",
  "progress.section.progress.past_year": "Past 12 Months",
  "progress.section.progress.past_3_months": "Past 3 Months",
  "progress.section.progress.past_month": "Past Month",
  "progress.section.progress.past_14_days": "Past 14 Days",
  "progress.section.progress.year": "Yearly Progress",
  "progress.section.progress.quarter": "Quarterly Progress",
  "progress.section.progress.month": "Monthly Progress",
  "progress.section.progress.week": "Weekly Progress",
  "progress.section.metric-progress": "Metric Progress",
  "progress.section.training-stats": "Training Stats",
  "progress.section.no-data": "No data to display yet!",

  "progress.training-focus.title": "Training Focus",
  "progress.training-focus.focus": "Focus on {{metric}} - it’s where you have the most room to improve.",
  "progress.training-focus.empty.title": "Let's find your Training Focus",
  "progress.training-focus.empty.description": "Analyze your performance to discover where you have the most room to improve",
  "progress.training-focus.based-on": "Based on your past 30 days of training",
  "progress.training-focus.snackbar": "Set up your Training Focus",
  "progress.training-focus.analyze": "Analyze my performance",
  "progress.training-focus.improve": "How to Improve",

  "progress.training.streak": "Training Streak",
  "progress.training.streak.days": "Days",
  "progress.training.streak.weeks": "Weeks",
  "progress.training.weekly-training": "Weekly Training",
  "progress.training.total-training-time": "Total Training Time",
  "progress.training.avg-session-duration": "Avg Session Duration",
  "progress.training.total-sessions": "Total Sessions",
  "progress.training.monthly": "Monthly Training",
  "progress.training.days": "Days",

  "progress.byb_iq.last_5_sessions": "Last 5 sessions",
  "progress.byb_iq.score": "{{ byb_iq }} BYB IQ",

  "progress.feedback.learning.excellent": "Outstanding improvement — keep pushing your limits!",
  "progress.feedback.learning.strong": "Consistent performance — stay on track!",
  "progress.feedback.learning.fair": "Solid foundation – keep building your skills.",
  "progress.feedback.learning.poor": "Early stage – lots of room to grow.",

  "progress.feedback.performance.excellent": "Elite level — stay sharp and keep pushing!!",
  "progress.feedback.performance.strong": "Consistent performance — stay on track!",
  "progress.feedback.performance.fair": "Decent effort — but room for improvement.",
  "progress.feedback.performance.poor": "Momentum lost — time to reset and refocus.",

  "progress.increase": "increase",

  "progress.trend.label": "Progress Trend",
  "progress.trend.explanation":
    "Progress Trend is your short-term momentum and performance shifts comparing your last 10 sessions against your average in the selected time period.",
  "progress.trend.recent_sessions": "Last 5 sessions vs Avg",
  "progress.trend.performance.great": "Great",
  "progress.trend.performance.refocus": "Refocus",
  "progress.trend.performance.stable": "Stable",

  "progress.skill-radar.title": "Current Performance",
  "progress.skill-radar.recent": "Recent",
  "progress.skill-radar.previous": "Previous",
  "progress.skill-radar.not-available": "Not available",

  "progress.training-streak.weekly-goal": "Weekly Goal",
  "progress.training-streak.weekly": "This week",
  "progress.training-streak.monthly": "This month",
  "progress.training-streak.total.time": "Total",
  "progress.training-streak.total.sessions": "Total",

  "progress.bootcamp.description":
    "The Progress screen tracks your performance, metrics, and growth over time. Here you'll see your BYB IQ, skill trends, training stats, and detailed insights into your development.",
  "progress.bootcamp.cta": "Come back once you finish bootcamp to unlock your full progress dashboard!",
  "progress.bootcamp.button": "Go to next bootcamp challenge",

  "progress.demo.cta": "This feature is only available with a full subscription. Upgrade to unlock it!",
  "progress.demo.button": "Go to challenges",
};

const progressPageMobile = {
  "progress.snapshot.title": "Snapshot",
  "progress.performance.title": "Performance",
  "progress.performance.your-performance": "Your Performance",
};

const progressMetrics = {
  "progress.metrics.title": "Your Metrics",
};

const progressCareer = {
  "progress.career.status.progress.base": "{{ divisions }} Divisions to {{ league }} League",
  "progress.career.status.progress.last": "Complete challenge to reach {{ league }} League",
};

const motivators = {
  "weekly-progress.outcome.excellent-1": "Your hard work last week really paid off. You've shown exceptional progress across all metrics!",
  "weekly-progress.outcome.excellent-2": "Outstanding performance! Your dedication to improvement is clearly visible in the numbers.",
  "weekly-progress.outcome.excellent-3": "Remarkable achievement! You've set new personal bests and maintained consistently high performance.",

  "weekly-progress.outcome.strong-1": "You performed consistently above your targets. Keep this momentum going!",
  "weekly-progress.outcome.strong-2": "Solid progress across the board. Your commitment to training is showing great results.",
  "weekly-progress.outcome.strong-3": "Strong performance last week! You're developing good training habits and it shows.",

  "weekly-progress.outcome.fair-1": "You met most of your weekly targets. Focus on consistency to push your performance higher.",
  "weekly-progress.outcome.fair-2": "A balanced week of training. Let's work on turning these sessions into breakthrough moments.",
  "weekly-progress.outcome.fair-3": "You're on track with your targets. Small adjustments could lead to bigger gains.",

  "weekly-progress.outcome.poor-1": "Every session is a chance to improve. Let's break down your goals into smaller, achievable steps.",
  "weekly-progress.outcome.poor-2": "Training is about long-term progress. Focus on building consistent habits and the results will come.",
  "weekly-progress.outcome.poor-3": "Keep pushing forward. Small improvements in each session add up to significant progress over time.",
};

export const progress = {
  ...progressPage,
  ...motivators,
  ...progressPageMobile,
  ...progressMetrics,
  ...progressCareer,
};
